import { render } from "./teamComponent.vue?vue&type=template&id=511bad86"
import script from "./teamComponent.vue?vue&type=script&lang=js"
export * from "./teamComponent.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__